import { Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useApp } from '../hooks/AppProvider';
import LoadingDotsPage from './loading/LoadingDotsPage';
import UnauthorizedAccess from '../UnauthorizedAccess';

function PrivateRoute({ children, level }) {
    let app = useApp();
    let [authorize, setAuthorize] = useState(-1);

    if(app.emptyCheck(level) || typeof level !== "number")
        level = 0;

    useEffect(() => {
        switch(app.isLogin()) {
            case -1:
                app.reload(() => {                    
                    setAuthorize(app.getPrivilegeLevel()==-1?0:1);
                });
                break;
            
            case 0:
                setAuthorize(0);
                break;
                
            case 1:                
                setAuthorize(app.getPrivilegeLevel()==-1?0:1);
                break;
            }
    }, [app.location]);  

    return (
        <>
        {authorize === -1 && <LoadingDotsPage />}
        {authorize === 0 && <Navigate to="/login" replace />}
        {authorize === 1 && app.getPrivilegeLevel() >= level?(children!=undefined?children:<Outlet />):<UnauthorizedAccess />}
        </>
    )
        
}

export default PrivateRoute;